import React, { FunctionComponent } from 'react';
import { UploadView } from '../components';
import { parseConfig } from './model';
import { fixSpecs } from './fix-specs';
import { Role } from "../constants";

export const ProgramView: FunctionComponent = () => (
    <UploadView
        id="program-upload-view"
        requiredRole={Role.Programs}
        label="Program"
        apiPath="unit/programs"
        parseConfig={parseConfig}
        fixSpecs={fixSpecs}
        uploadType="program"
        templateFlowEnabled={true}
        entityName='Program'
        entityCSVModel={UnitProgramCSVModel}
    />
);

const UnitProgramCSVModel: Array<string> = [
    'id',
    'program_slug',
    'start_date',
    'end_date',
    'billing_cycle',
    'is_draft',
    'program_fields',
    'notes',
    'billing_amount_per_cycle_cost',
    'billing_amount_per_cycle_default',
    'billing_amount_per_cycle_actual',
    'is_setup',
    'billing_amount_setup_cost',
    'billing_amount_setup_default',
    'billing_amount_setup_actual',
    'created_by',
    'modified_by',
    'owner_notes'
];
